import React, { useState } from 'react'
import { Dialog } from 'primereact/dialog'
import { RadioButton } from 'primereact/radiobutton'

import Text from '../../../../ui/Text'
import useText from '../../../hooks/useText'
import { LoadbalancerSetupType } from '../../../enums/infographicsEnum'

export type LoadbalancerInfoModalProps = {
    openInfoModal: boolean
    close: () => void
    measurementDeviceId: number
}

export const LoadbalancerInfoModal = React.memo(function LoadbalancerInfoModal({
    openInfoModal,
    close,
    measurementDeviceId,
}: LoadbalancerInfoModalProps): React.ReactElement {
    const text = useText()
    const [loadblancerSetupType, setLoadbalancerSetupType] = useState<LoadbalancerSetupType>(
        measurementDeviceId
            ? LoadbalancerSetupType.ChargersAreIncludedInPowerConsumption
            : LoadbalancerSetupType.WithoutMeasurementDevice
    )
    return (
        <Dialog
            header={text('lblLBSetupModal')}
            data-testid="lb-inforaphics-modal"
            visible={openInfoModal}
            onHide={close}
        >
            <div className="flex gap-2 h-300">
                <div className="flex flex-column gap-5 mt-2">
                    <div className="flex gap-2 align-items-center">
                        <RadioButton
                            data-testid="btn-1"
                            inputId="image1"
                            onChange={() => setLoadbalancerSetupType(LoadbalancerSetupType.WithoutMeasurementDevice)}
                            checked={loadblancerSetupType === LoadbalancerSetupType.WithoutMeasurementDevice}
                        />
                        <Text code="btnFilterWithoutMeasurementDeviceLink" />
                    </div>
                    <div className="flex gap-2 align-items-center">
                        <RadioButton
                            data-testid="btn-2"
                            inputId="image2"
                            onChange={() =>
                                setLoadbalancerSetupType(LoadbalancerSetupType.ChargersAreIncludedInPowerConsumption)
                            }
                            checked={
                                loadblancerSetupType === LoadbalancerSetupType.ChargersAreIncludedInPowerConsumption
                            }
                        />
                        <Text code="btnFilterChargersIncludedInMNeasurementLink" />
                    </div>
                    <div className="flex gap-2 align-items-center">
                        <RadioButton
                            data-testid="btn-3"
                            inputId="image3"
                            onChange={() =>
                                setLoadbalancerSetupType(LoadbalancerSetupType.ChargersAreNotIncludedInPowerConsumption)
                            }
                            checked={
                                loadblancerSetupType === LoadbalancerSetupType.ChargersAreNotIncludedInPowerConsumption
                            }
                        />
                        <Text code="btnFilterChargersNotIncludedInMeasurementLink" />
                    </div>
                </div>
                {loadblancerSetupType && (
                    <div className="ml-5" data-testid="img-container">
                        <img src={loadblancerSetupType} alt="LB config image" height="500" width="500"></img>
                    </div>
                )}
            </div>
        </Dialog>
    )
})
